import React from "react";
import { Switch } from "@commonsku/design-system";
import { LuCheck } from "react-icons/lu";

export interface AutomationEnableSwitchProps {
  isChecked: boolean;
  disabled?: boolean;
  label?: string;
  onCheckedChange: (checked: boolean) => void;
}

const AutomationEnableSwitch = ({
  isChecked,
  disabled = true,
  label,
  onCheckedChange,
}: AutomationEnableSwitchProps) => {
  return (
    <Switch.Root
      checked={isChecked}
      disabled={disabled}
      size="lg"
      onCheckedChange={(details: { checked: boolean }) =>
        onCheckedChange(details.checked)
      }
    >
      <Switch.HiddenInput
        aria-label={label ?? "Enable automation"}
      />
      <Switch.Control padding="0.5">
        <Switch.Thumb boxSize="5" scale="1">
          {isChecked && <LuCheck size={16} />}
        </Switch.Thumb>
      </Switch.Control>
      {label && <Switch.Label>{label}</Switch.Label>}
    </Switch.Root>
  );
};

export default AutomationEnableSwitch;
